"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledComponentsModifiers = require("styled-components-modifiers");

var _polished = require("polished");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const modifierConfig = {
  error: ({
    theme
  }) => "\n    border-color: ".concat(theme.palette.primary[1], ";\n  "),
  withIcon: () => "\n    padding-left: 40px;\n  "
};

const Input = _styledComponents.default.input.withConfig({
  displayName: "Input"
})(["width:100%;height:36px;box-sizing:border-box;font-size:", ";margin:0;margin-top:5px;padding-left:0px;padding-bottom:5px;border-top:none;border-left:none;border-right:none;border-bottom:2px solid;border-color:", ";transition:border-color ease 250ms;&:focus{outline:none;border-color:", ";}&::placeholder{color:", ";opacity:1;}", ";"], (0, _polished.rem)('18px'), props => props.theme.palette.border, props => props.theme.palette.primary[0], props => props.theme.palette.label, (0, _styledComponentsModifiers.applyStyleModifiers)(modifierConfig));

var _default = Input;
exports.default = _default;